"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetBaseTokenURIButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const setBaseURI_json_1 = __importDefault(require("@framework/abis/json/ERC721Simple/setBaseURI.json"));
const utils_1 = require("../../../../utils");
const dialogs_1 = require("../../../../dialogs");
const validation_1 = require("./dialog/validation");
const SetBaseTokenURIButton = (props) => {
    const { className, contract, contract: { address, contractFeatures, baseTokenURI, contractType, accessControls }, disabled, variant, } = props;
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const hasPermission = accessControls.some(item => item.role === types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE);
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        return writeContractAsync({
            address: address,
            abi: setBaseURI_json_1.default,
            functionName: "setBaseURI",
            args: [values.baseTokenURI],
        });
    });
    const handleBaseTokenURIConfirmed = async ({ data }) => {
        await metaFn(data);
    };
    const handleBaseTokenURI = () => {
        openDialog(dialogs_1.GlobalDialogKeys.SET_BASE_TOKEN_URI, contract, {
            initialValues: {
                baseTokenURI,
            },
            validationSchema: validation_1.editBaseTokenURIValidationSchema,
            message: "dialogs.edit",
            testId: "BaseTokenURIEditForm",
            onExternalConfirm: handleBaseTokenURIConfirmed,
        });
    };
    if (contractType === types_1.TokenType.NATIVE || contractType === types_1.TokenType.ERC20) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleBaseTokenURI, icon: icons_material_1.Link, message: "form.buttons.baseTokenURI", className: className, dataTestId: "SetTokenURIButton", disabled: disabled ||
            (0, utils_1.shouldDisableByContractType)(contract) ||
            contractFeatures.includes(types_1.ContractFeatures.SOULBOUND) ||
            !hasPermission, variant: variant }));
};
exports.SetBaseTokenURIButton = SetBaseTokenURIButton;
//# sourceMappingURL=index.js.map